import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import startOfDay from 'date-fns/startOfDay';

export interface ReportECFilters {
  dateStart: Date;
  dateEnd: Date;
  paymentType: string;
  userCode: string;
  idClientCartorio?: string;
  idServiceCartorio?: string;
}

export interface ReportECUsers {
  data: Array<{ CdUsuario: string | number; NmUsuario: string }> | null;
  loading: boolean | null;
  error: any;
  handleFetch: () => void;
}

export interface ReportECTransaction {
  CdTransacao: string | number;
  IdTransacao?: string | number | null;
  Referencia?: string | number | null;
  DtTransacao?: string;
  VlTransacao?: number | string;
  VlLiberado?: number | string;
  VlTaxas?: number | string;
  TpPagamento?: string;
  QtdParcelas?: number;
  Status?: string;
  DsIdentificacaoCliente?: string;
  DsIdentificacaoServico?: string;
  Split?: Array<{
    VlLiberado?: number | string;
    TpPagamento?: string;
    QtdParcelas?: number;
    NmClienteSplit?: string;
  }>;
}

export const createReportECFilters = (
  userCode = '',
  identification = false
): ReportECFilters => ({
  dateStart: startOfDay(new Date()),
  dateEnd: startOfDay(new Date()),
  paymentType: '',
  userCode,
  ...(identification ? { idClientCartorio: '', idServiceCartorio: '' } : {}),
});

export const isSameReportECFilters = (draft: ReportECFilters, applied: any) =>
  ['dateStart', 'dateEnd'].every(
    (key) =>
      applied?.[key] &&
      startOfDay(new Date(draft[key])).getTime() ===
        startOfDay(new Date(applied[key])).getTime()
  ) &&
  draft.paymentType === (applied?.paymentType || '') &&
  String(draft.userCode) === String(applied?.userCode || '') &&
  (draft.idClientCartorio || '') === (applied?.idClientCartorio || '') &&
  (draft.idServiceCartorio || '') === (applied?.idServiceCartorio || '');

export const formatReportDate = (value?: string) => {
  // Preserva a exibição do horário local utilizada pelo relatório legado.
  const date = value ? new Date(value.replace(/Z$/, '')) : null;
  return date && isValid(date) ? format(date, 'dd/MM/yyyy HH:mm') : '—';
};

export const formatReportMoney = (value?: number | string) =>
  Number(value || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

export const getReportAuthorization = (
  transaction: Pick<ReportECTransaction, 'IdTransacao' | 'Referencia'>
) =>
  String(transaction.IdTransacao ?? '').trim() ||
  String(transaction.Referencia ?? '').trim();
